import { z } from 'zod';

export const confirm = (annotationId: number) => {
  return {
    endpoint: `/annotations/${annotationId}/confirm`,
    method: 'POST',
    responseSchema: z.unknown(),
  } as const;
};
